import { Directive, HostListener } from '@angular/core';

/**
 * DisableCopyDirective
 * --------------------------
 * This Angular directive disables copy and cut actions on the host element.
 *
 * Usage:
 * Apply the directive as an attribute to any input or textarea element:
 *   <input type="text" appDisableCopy />
 *
 * Features:
 * - Listens to 'copy' and 'cut' events on the host element.
 * - Prevents the default behavior of each event, effectively disabling clipboard actions.
 */

@Directive({
  selector: '[appDisableCopy]',
  standalone: true,
})
export class DisableCopyDirective {
  @HostListener('copy', ['$event']) onCopy(event: ClipboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  @HostListener('cut', ['$event']) onCut(event: ClipboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
